module.exports = __webpack_public_path__ + "static/media/child.9ee03fd0.svg";